import { TasksListSettings } from 'src/app/shared/tasks-list-settings';

export class AlcmeonContext {
  jwt?: string;
  jwtTimestamp: number;
  jwtShort?: string;
  jwtShortTimestamp: number;
  companyId?: number;
  siteId?: number;
  companyCode?: string;
  isSaml?: boolean;
  samlConfigId?: number;
  lang?: string;
  taskListSettings?: TasksListSettings;
}
